import styles from './styles.module.scss';
import { FC } from 'react';

type VehicleInfoProps = {
  vehicleInfo?: string | null;
};

export const VehicleInfo: FC<VehicleInfoProps> = ({ vehicleInfo }) => (
  <div>
    <div className="fs-6">Found Vehicle</div>
    <div className={styles.vehicleInfo}>{vehicleInfo ?? '-'}</div>
  </div>
);
